import { render, staticRenderFns } from "./SuccessStories.vue?vue&type=template&id=bed1e8e0&scoped=true"
import script from "./SuccessStories.vue?vue&type=script&lang=js"
export * from "./SuccessStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed1e8e0",
  null
  
)

export default component.exports